import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { resolveAnalyticsConfig } from './app/@assetaccountant/core/analytics/analytics-config';
import { initDatadogRum } from './app/@assetaccountant/core/analytics/analytics-vendors';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Before bootstrap so RUM measures the initial load. A no-op on hosts without Datadog config.
initDatadogRum(resolveAnalyticsConfig());

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
